<template>
    <!-- 告警推送设置 -->
    <div class="pushSetting_main" :class="{'cn':version == '1'}">
        <div class="pushSetting_top">
            <div class="box btn" @click="linkToFun('/service')">
                <i class="iconfont icon-back"></i><span class="span1">{{$t('App.room_light.text1')}}</span>
            </div>
            <div class="l"></div>
            <div class="box"><span class="span2">{{$t('App.sideBar.text11')}} →</span></div>
            <div class="box">
                <span class="span1">{{$t('App.service.text2')}}</span>
            </div>
        </div>
        <div class="pushSetting_content">
            <div class="content_left">
                <el-select v-model="hotelType">
                    <el-option
                        v-for="item in hotelTypeArr"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
                <div class="ul scrollbar_style scrollbar_style_show">
                    <div class="li" :class="{'select':hotelId == item.id}" v-for="item in hotelNavList" :key="item.id" @click="hotelSelectFun(item)">
                        <div class="li_box1">
                            <div class="li_box1_l">
                                <div class="img_box">
                                    <img :src="item.avatar">
                                </div>
                                <div class="text_box" :title="item.name">{{item.name}}</div>
                            </div>
                        </div>
                        <div class="li_box2">
                            <p>{{item.location}}</p>
                        </div>
                        <div class="li_box3">
                            <div class="li_box3_l">{{$t('App.service.text41')}}</div>
                            <div class="li_box3_r">{{item.pushCount}}</div>
                        </div>
                        <div class="border"></div>
                    </div>
                </div>
            </div>
            <div class="content_right">
                <div class="toolbar">
                    <div class="toolbar_l">
                        <el-input placeholder="search for keywords" v-model="keywords" @keyup.native="getSendUserListKeyUp($event)" class="input-with-select">
                            <i slot="suffix" class="el-input__icon el-icon-search" @click="getSendUserList()"></i>
                        </el-input>
                    </div>
                    <div class="toolbar_r">
                        <div class="btn" @click="addMaintenanceStaffFun()">
                            <img :src="img_newMaintenanceStaff">
                            <span>{{$t('App.service.text42')}}</span>
                        </div>
                    </div>
                </div>
                <div class="table_box">
                    <el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange">
                        <el-table
                            ref="pushDataList"
                            v-loading="loading.pushDataList"
                            element-loading-background="rgba(0, 0, 0, 0.5)"
                            height="100%"
                            :data="pushDataList">
                            <el-table-column
                                :label="$t('App.lights.text33')"
                                :prop="'index'"
                                align="center"
                                :width="100">
                                <template slot-scope="scope">
                                    <!-- <el-checkbox :label="scope.row.id" :key="scope.row.id">{{scope.row.webIndex}}</el-checkbox> -->
                                    {{scope.row.webIndex}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                v-for="(item) in repairArr"
                                :key="'table_'+item.prop"
                                :prop="item.prop"
                                :label="item.label"
                                :align="item.align?item.align:'center'"
                                :width="item.width"
                                :show-overflow-tooltip="true"
                                :min-width="item.minWidth">

                                <template slot-scope="scope">
                                    <div v-if="item.type != 1">{{scope.row[item.prop]}}{{item.unit?item.unit:''}}</div>
                                    <div v-if="item.prop == 'deviceNum'" class="deviceNum">
                                        <!-- {{scope.row.deviceNum.split(',').indexOf('0')}} -->
                                        <img :src="img_lights_0" v-if="scope.row[item.prop].split(',').indexOf('0')!= -1">
                                        <img :src="img_lights_1" v-if="scope.row[item.prop].split(',').indexOf('1')!= -1">
                                        <img :src="img_lights_2" v-if="scope.row[item.prop].split(',').indexOf('2')!= -1">
                                        <img :src="img_lights_3" v-if="scope.row[item.prop].split(',').indexOf('3')!= -1">
                                    </div>
                                    <div v-if="item.prop == 'enable'" class="enable">
                                        <span class="pl_switch" :class="{'checked':scope.row['enable'] == 1}" @click="plSwitchFun(scope.row)" v-loading="scope.row.statusLoading"></span>
                                    </div>
                                    <div v-if="item.prop == 'pushMode'" class="pushMode">{{pushModeArr[scope.row[item.prop].split(',')[0]]}} {{pushModeArr[scope.row[item.prop].split(',')[1]]}} {{pushModeArr[scope.row[item.prop].split(',')[2]]}}</div>
                                </template>
                                </el-table-column>
                                <el-table-column
                                align="center"
                                :min-width="100"
                                :label="$t('App.lights.text6')">
                                <template slot-scope="scope">
                                    <span class="btn" @click="editInfo(scope.row)" :title="$t('App.lights.text7')">
                                        <i class="iconfont icon-suo"></i>
                                    </span>
                                    <span class="btn" @click="postDelRepair(scope.row)" :title="$t('App.lights.text1')">
                                        <i class="iconfont icon-delete"></i>
                                    </span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-checkbox-group>
                    <!-- <div class="pagination_box">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-size="pageSize"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </div> -->
                </div>
            </div>
            
        </div>
        <!-- 添加编辑维修人员 -->
        <div class="pushSetting_wrap scrollbar_style" v-show="maintenanceStaffTkShowbg">
            <div class="pushSetting_wrap_bg" @click="addSendUseClose()"></div>
            <div class="pushSetting_box" :class="{'pushSetting_tk_show':maintenanceStaffTkShow}">
                <div class="pushSetting_title">
                    <span class="span1">{{maintenanceStaffTkTitle}}</span>
                    <span class="span2" @click="addSendUseClose()">{{$t('App.close')}}</span>
                </div>
                <div class="form">
                    <div class="form_item" v-if="maintenanceStaffTkTitle == $t('App.service.text42')">
                        <span class="laber">{{$t('App.service.text44')}}</span>
                        <!-- <el-input v-model="pushSettingForm.name" placeholder="Please enter device name"></el-input> -->
                        <el-dropdown @command="commandUser" trigger="click" @visible-change="commandHide('dropdown_pushSetting_user')">
                            <span class="span1">{{commandUserName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_pushSetting_user">
                                <el-dropdown-item v-for="item in userNav" :command="item" :key="'room'+item.id" :class="{'select':item.id==pushSettingForm.userId}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="check_box">
                        <p class="p1">{{$t('App.service.text67')}}</p>
                        <el-checkbox-group v-model="pushSettingForm.pushMode">
                            <el-checkbox label="0" key="0" value="0">sms</el-checkbox>
                            <el-checkbox label="1" key="1" value="1">E-mail</el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <div class="check_box">
                        <p class="p1">{{$t('App.service.text46')}}</p>
                        <el-checkbox-group v-model="pushSettingForm.deviceNum">
                            <el-checkbox label="0" key="0" value="0">{{$t('App.dashboard.text32')}}</el-checkbox>
                            <el-checkbox label="1" key="1" value="1" v-if="domainName != 'plant'">{{$t('App.dashboard.text33')}}</el-checkbox>
                            <el-checkbox label="1" key="1" value="1" v-if="domainName == 'plant'">{{$t('App.dashboard.text59')}}</el-checkbox>
                            <el-checkbox label="2" key="2" value="2">{{$t('App.dashboard.text34')}}</el-checkbox>
                            <el-checkbox label="3" key="3" value="3">{{$t('App.dashboard.text35')}}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="postAddSendUser()">{{$t('App.done')}}</div>
                </div>
            </div>
        </div>
        <!-- 维修人员权限 -->
    </div>
</template>

<script type="text/javascript">

    import { mapGetters } from 'vuex'
    import allUrl from '../../api/allUrl.js'
    import base from '../../api/base.js'

	export default {
		name:'maintenanceStaff',
		data () {
			return{
                hotelType:'0',
                hotelTypeArr:[{id:'0',name:'All hotel'},{id:'1',name:'Configured'},{id:'2',name:'Not configured'}],
                keywords:'',
                hotelTime:null,

                userNav:[],
                hotelId:'',
                cityId:'',

                hotelNavList:[],
                pushModeArr:['sms','E-mail'],


                checkAll:false,
                isIndeterminate:false,
                checkList:[],

                repairArr:[],
                pushDataList:[],
                repairDataIdList:[],
                maintenanceStatusArr:['Maintenance','Repaired','No maintenance'],

                currentPage:1,
                pageSize:20,
                total:0,

                maintenanceStaffTkTitle:'',
                maintenanceStaffTkShowbg:false,
                maintenanceStaffTkShow:false,
                pushSettingForm:{
                    userId:'',
                    pushMode:[],
                    deviceNum:[],
                },
                pushSettingFormId:'',

                jurisdictionTkShowbg:false,
                jurisdictionTkShow:false,


				loading:{
				},

                img_newMaintenanceStaff:'',
                img_lights_0:'',
                img_lights_1:'',
                img_lights_2:'',
                img_lights_3:'',
			}
		},
        computed:{
            ...mapGetters({
                token:'token',
                client_key:'client_key',
                username:'username',
                version:'version',
                headerIdStr:'headerIdStr',
                domainName: 'domainName',
            }),
            commandUserName(){
                let name;
                for(let d of this.userNav){
                    if(d.id == this.pushSettingForm.userId){
                        name = d.name;
                    }
                }
                return name;
            }
        },
		components:{
			// 'sideBar':sideBar
		},
		mounted(){
            this.img_newMaintenanceStaff = require('../../img/newMaintenanceStaff.png');
            this.img_lights_0 = require('../../img/device_0_2.png');
            this.img_lights_1 = require('../../img/device_1_2.png');
            this.img_lights_2 = require('../../img/device_2_2.png');
            this.img_lights_3 = require('../../img/device_3_2.png');
            if(this.version == '1'){
                this.img_newMaintenanceStaff = require('../../img/newMaintenanceStaff_v1.png');
                this.img_lights_0 = require('../../img/device_0_2_v1.png');
                this.img_lights_1 = require('../../img/device_1_2_v1.png');
                this.img_lights_2 = require('../../img/device_2_2_v1.png');
                this.img_lights_3 = require('../../img/device_3_2_v1.png');
            }

            this.hotelTypeArr = [{id:'0',name:this.$t('App.service.text47')},{id:'1',name:this.$t('App.service.text48')},{id:'2',name:this.$t('App.service.text49')}];
            this.pushModeArr = [this.$t('App.sms'),this.$t('App.email')];
            this.maintenanceStatusArr = [this.$t('App.service.text16'),this.$t('App.service.text17'),this.$t('App.service.text15')];

            this.$store.commit('SIDEBARSHOW',{
                sideBarShow:false,
            })

            this.repairArr = [
                {prop:'repairname',label:this.$t('App.name'),minWidth:70},
                {prop:'hotelname',label:this.$t('App.service.text50'),minWidth:100},
                {prop:'phone',label:this.$t('App.service.text51'),minWidth:150},
                {prop:'email',label:this.$t('App.email'),minWidth:100},
                {prop:'deviceNum',label:this.$t('App.service.text46'),minWidth:100,type:1},
                {prop:'pushMode',label:this.$t('App.service.text45'),minWidth:100,type:1},
                {prop:'enable',label:this.$t('App.service.text52'),minWidth:100,type:1},
            ];
            if(this.headerIdStr){
                let ids = this.headerIdStr.split('_');
                if(ids[2]){
                    this.cityId = ids[2]
                }else{
                    if(ids[1]){
                        this.cityId = ids[1]
                    }else{
                        if(ids[0]){
                            this.cityId = ids[0]
                        }
                    }
                    
                }
                this.hotelNav(this.cityId);
            }
		},
		methods:{
			linkToFun(val){
				this.$router.push({path:val});
				this.$store.commit('ROUTERSTRFUN',{
					routerStr:val,
				})
			},
            commandHide(val){
                this.$nextTick(function(){
                    if($('.'+val)&&$('.'+val+' >.select').offset()){
                        $('.'+val).animate({scrollTop: $('.'+val).scrollTop() + $('.'+val+' >.select').offset().top - $('.'+val).offset().top - 100})
                    }
                })
            },
            hotelSelectFun(data){
                if(data.id != this.hotelId){
                    this.hotelId = data.id;
                }
            },
            /*酒店列表*/
            hotelNav(cityId){
                base.ajax_post(
                    allUrl.service.hotelNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        type:this.hotelType,
                        cityId:cityId,
                    },
                    {},
                    data=>{
                        this.hotelNavList = data.data.list;
                        if(this.hotelNavList.length>0){
                            this.hotelId = this.hotelNavList[0].id;
                        }
                    },
                    this
                )
            },
            /*设备列表*/
            getSendUserListKeyUp(e){
                if(e.key == 'Enter'){
                  this.getSendUserList();
                }
            },
            getSendUserList(callback){
                base.ajax_post(
                    allUrl.service.sendUserList,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        hotelId:this.hotelId,
                    },
                    {},
                    data=>{
                        this.pushDataList = data.data.list;
                        this.total = Number(data.data.total);

                        this.repairDataIdList = [];
                        this.checkList = [];
                        this.isIndeterminate = false;
                        for(let d of this.pushDataList){
                            this.$set(d,'statusLoading',false);
                        }

                        let i = 1 + (this.currentPage-1)*this.pageSize;
                        for(let d of this.pushDataList){
                            d.webIndex = i;
                            i++;
                        }
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*用户下拉列表*/
            getUserNav(callback){
                base.ajax_post(
                    allUrl.service.addSendList,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        hotelId:this.hotelId,
                    },
                    {},
                    data=>{
                        this.userNav = data.data.list;
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            commandUser(data){
                this.pushSettingForm.userId = data.id;
            },
            editInfo(data){
                this.maintenanceStaffTkTitle = this.$t('App.service.text43');
                this.maintenanceStaffTkShowbg = true;
                this.$nextTick(function(){
                    this.maintenanceStaffTkShow = true;
                })

                this.pushSettingFormId = data.id;
                this.pushSettingForm.userId = data.repairId;
                this.pushSettingForm.pushMode = data.pushMode.split(',');
                this.pushSettingForm.deviceNum = data.deviceNum.split(',');
                console.log(this.pushSettingForm.deviceNum)
                // this.pushSettingForm.email = data.email;
            },
            /*添加编辑设备*/
            addMaintenanceStaffFun(){

                if(this.userNav.length > 0){
                    this.pushSettingForm.userId = this.userNav[0].id;
                }
                this.pushSettingFormId = '';
                // this.pushSettingForm.userId = '';
                this.pushSettingForm.pushMode = [];
                this.pushSettingForm.deviceNum = [];
                this.maintenanceStaffTkTitle = this.$t('App.service.text42');
                this.maintenanceStaffTkShowbg = true;
                this.$nextTick(function(){
                    this.maintenanceStaffTkShow = true;
                })
            },
            addSendUseClose(){
                let this_ = this;
                this.maintenanceStaffTkShow = false;
                setTimeout(function(){
                    this_.maintenanceStaffTkShowbg = false;
                },400)
            },
            postAddSendUser(){
                let this_ = this;
                console.log(this.pushSettingForm.pushMode,this.pushSettingForm.pushMode.join(','))
                base.ajax_post(
                    allUrl.service.addSendUser,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        hotelId:this.hotelId,
                        id:this.pushSettingFormId,
                        repairId:this.pushSettingForm.userId,
                        pushMode:this.pushSettingForm.pushMode.join(','),
                        deviceNum:this.pushSettingForm.deviceNum.join(','),
                    },
                    {},
                    data=>{
                        this.$message({
                          showClose: true,
                          message: data.msg,
                          type: 'success'
                        });
                        this.maintenanceStaffTkShow = false;
                        setTimeout(function(){
                            this_.maintenanceStaffTkShowbg = false;
                        },400)
                        this.getSendUserList();
                    },
                    this
                )
            },
            /*删除维修人员*/
            postDelRepair(obj){
                let isTrue = true;
                // if(type == 'batch'){
                //     if(obj.length == 0){
                //         isTrue = false;
                //         this.$message({
                //             message: 'Unchecked',
                //             type: 'warning'
                //         });
                //     }else{
                //         for(let id of obj){
                //             if(repairId == ''){
                //                 repairId = id;
                //             }else{
                //                 repairId += ','+id;
                //             }
                //         }
                //     }
                // }else{
                    // repairId = obj.id;
                // }
                if(isTrue){
                    this.$confirm(
                        this.$t('App.message.text25'), this.$t('App.message.text3'), {
                            confirmButtonText: this.$t('App.message.text2'),
                            cancelButtonText: this.$t('App.message.text6'),
                            type: 'warning'
                        }
                    ).then(() => {
                        base.ajax_post(
                            allUrl.service.delSendUser,
                            {
                                username:this.username,
                                client_key:this.client_key,
                                token:this.token,
                                repairId:obj.repairId,
                                id:obj.id,
                                hotelId:this.hotelId,
                            },
                            {},
                            data=>{
                                this.$message({
                                  showClose: true,
                                  message: data.msg,
                                  type: 'success'
                                });
                                this.getSendUserList();
                            },
                            this
                        )
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: this.$t('App.message.text18')
                        });          
                    });
                }
            },
            plSwitchFun(data){
                if(!data.statusLoading){
                    if(data.enable == 1){
                        data.enable = 0
                    }else{
                        data.enable = 1
                    }
                    data.statusLoading = true;
                    base.ajax_post(
                        allUrl.service.setSendUserStatus,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            repairId:data.repairId,
                            // id:data.id,
                            enable:data.enable,
                            hotelId:this.hotelId,
                        },
                        {},
                        obj=>{
                            this.$message({
                              showClose: true,
                              message: obj.msg,
                              type: 'success'
                            });
                            data.statusLoading = false;
                            // this.getSendUserList();
                        },
                        this,
                        ()=>{
                            data.statusLoading = false;
                        }
                    )
                    
                }
            },
            /*分页*/
            handleSizeChange(val) {
                this.pageSize = val;
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getSendUserList();
                // console.log(val)
            },
            handleCheckAllChange(val) {
                this.checkList = val ? this.repairDataIdList : [];
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value){
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.repairDataIdList.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.repairDataIdList.length;
            },
        },
        watch:{
            hotelId:function(){
                if(this.hotelId){
                    this.getUserNav(()=>{
                        if(this.userNav.length > 0){
                            this.pushSettingForm.userId = this.userNav[0].id;
                        }
                    });
                    this.currentPage = 1;
                    this.getSendUserList()
                }
            },
            hotelType(){
                if(this.hotelId){
                    this.hotelNav(this.cityId);
                }

            },
            headerIdStr(){
                let this_ = this;
                let ids = this.headerIdStr.split('_');
                console.log(this.headerIdStr,ids)
                if(ids[2]){
                    this.cityId = ids[2]
                }else{
                    if(ids[1]){
                        this.cityId = ids[1]
                    }else{
                        if(ids[0]){
                            this.cityId = ids[0]
                        }
                    }
                    
                }
                clearTimeout(this.hotelTime)
                this.hotelTime = setTimeout(function(){

                    this_.hotelNav(this_.cityId);
                },300)
            },
        }
    }
</script>

<style type="text/css" lang="less">
    .pushSetting_main{
		width: 100%;
		height: 100%;
		// height: 105rem;
		min-height: 50rem;
		// min-width: 120rem;
		margin: 0 auto;
		overflow: hidden;
		position: relative;
		background: #F6F8FA;
        &.cn{
            .pushSetting_content{
                .toolbar .toolbar_l > .el-input .el-icon-search{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                }
                .table_box{
                    .el-table .brightness .btn_img .bg{
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                    .el-table .enable .pl_switch.checked::after{
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                    .el-table .btn:hover i{
                        color: #8266C7;
                    }
                    .pagination_box .el-pager li{
                        &:hover{
                            color: #513C93;
                            background:rgba(130,102,199,0.1);
                        }
                        &.active{
                            color: #FFFFFF;
                            background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                        }
                    }
                }
            }
            .pushSetting_wrap .pushSetting_box{
                .form .check_box .el-checkbox__input{
                    &.is-checked .el-checkbox__inner{
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                        border-color: rgba(0,0,0,0);
                    }
                    &.is-indeterminate .el-checkbox__inner{
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                        border-color: rgba(0,0,0,0);
                    }
                }

                .table .tr .btn{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                }
                .btn_box .btn{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                }
            }
        }
        .pushSetting_top{
            display: flex;
            width: 100%;
            align-items: center;
            padding-left: 1rem;
            height: 2.67rem;
            background: #FFFFFF;
            box-shadow: 0 2px 6px 0 rgba(0,0,0,0.05);
            .span1{
                font-size:1rem;
                font-family:AlibabaPuHuiTiR;
                color:rgba(51,51,51,1);
            }
            .span2{
                font-family: AlibabaPuHuiTiR;
                font-size: 1rem;
                color: #A3AFBB;
            }
            .box{
                margin-left: 1rem;
            }
            .btn{
                line-height: 2.67rem;
                cursor: pointer;
                .iconfont{
                    margin-right: 0.5rem;
                    font-size: 0.8rem;
                }
            }
        }
        .pushSetting_content{
            display: flex;
            height: 100%;
            .content_left{
                width: 22rem;
                .el-select{
                    width: calc(100% - 3rem);
                    margin: 1.5rem 1.5rem 0;
                    .el-input__inner{
                        background:rgba(255,255,255,1);
                        border-radius:1.25rem;
                        border:0.1rem solid rgba(240,240,240,1);
                        height: 2.5rem;line-height:2.5rem;
                    }
                    .el-select__caret{
                        line-height:2.5rem;
                    }
                }
                .ul{
                    margin: 1.67rem 1.5rem 0;
                    width: calc(100% - 3rem);
                    padding-right: 0.5rem;
                    height: calc(100% - 10.3rem);
                    &.scrollbar_style_show::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
                        background: #f6f8fa;
                    }
                    .li{
                        width:calc(100% - 0.3rem);
                        height:10.67rem;
                        background:rgba(255,255,255,1);
                        position: relative;
                        cursor: pointer;
                        &.select{
                            cursor: initial;
                            box-shadow:0rem 0.17rem 1rem 0rem rgba(0,0,0,0.05);
                            .border{
                                position: absolute;
                                left: 0;top: 1.67rem;
                                width:0.17rem;
                                height:1.42rem;
                                background:rgba(5,207,171,1);
                            }
                        }
                        border-radius:0.5rem;
                        padding: 1.17rem 0 0 0;
                        margin-bottom: 0.83rem;
                        .li_box1{
                            display: flex;
                            justify-content: space-between;
                            // align-items: center;
                            height: 2.4rem;line-height: 2.4rem;
                            padding: 0 1.17rem;
                            .li_box1_l{
                                width: 100%;
                                display: flex;
                            }
                            .img_box{
                                width:2.33rem;height: 2.33rem;
                                border-radius: 50%;
                                overflow: hidden;
                                img{
                                    width: 100%;height: 100%;
                                }
                            }
                            .text_box{
                                width: calc(100% - 3rem);
                                margin-left: 0.67rem;
                                text-align: left;
                                font-size:1.17rem;
                                font-family:PingFangSC-Medium,PingFang SC;
                                font-weight:500;
                                color:rgba(51,51,51,1);
                                overflow: hidden;   
                                text-overflow:ellipsis;
                                white-space: nowrap;
                            }
                            .icon_box{
                                .iconfont{
                                    margin-left: 0.5rem;
                                    cursor: pointer;
                                    padding: 0.3rem;
                                    font-size: 0.75rem;
                                }
                                color: rgba(198, 205, 213, 1);
                            }
                        }
                        .li_box2{
                            height: 4.4rem;
                            font-size:1rem;
                            font-family:AlibabaPuHuiTiL;
                            color:rgba(101,112,133,1);
                            line-height:1.17rem;
                            padding: 1rem 1.17rem;
                        }
                        .li_box3{
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            border-top:1px solid rgba(235, 239, 242, 1);
                            padding: 0 1.17rem;
                            height: 2.67rem;line-height: 2.67rem;
                            .li_box3_l{
                                font-size:1rem;
                                font-family:AlibabaPuHuiTiL;
                                color:rgba(51,51,51,1);
                            }
                            .li_box3_r{
                                font-size:1rem;
                                font-family:AlibabaPuHuiTiR;
                                color:rgba(51,51,51,1);
                            }
                        }
                    }
                }
            }
            .content_right{
                width: calc(100% - 22rem);
                height: calc(100% - 3rem);
                // margin: 1.5rem 0;
                background-color:#fff;
                border: 1px solid rgba(240, 240, 240, 1);
            }
            .toolbar{
                padding: 1.67rem;
                display: flex;
                justify-content: space-between;
                .toolbar_l{
                    .el-input__inner{
                        height: 2.5rem;line-height: 2.5rem;
                        border-radius: 1.25rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #333333;
                        border-color: #F0F0F0;
                    }
                    .el-input__icon{
                        height: 2.5rem;line-height: 2.5rem;
                    }
                    >.el-input{
                        width: 18rem;
                        .el-icon-search{
                            display: inline-block;
                            top: 0;bottom: 0;
                            right: 0;
                            width: 4rem;
                            background: #05CFAB;
                            border-radius: 1.25rem;
                            cursor: pointer;
                            color: #FFFFFF;
                        }
                        .el-input__suffix{
                            right: 0;
                        }
                    }
                }
                .toolbar_r{
                    .btn{
                        margin-left: 1rem;
                        height: 2.5rem;line-height: 2.5rem;
                        padding: 0 1.25rem;
                        background: #FFFFFF;
                        border: 1px solid #F0F0F0;
                        border-radius: 1.25rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #333333;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        img{
                            margin-right: 0.5rem;
                            height: 1rem;
                        }
                    }
                }
            }
            .table_box{
                height: calc(100% - 6rem);
                margin: 0rem 1.67rem 0;
                .el-checkbox-group{
                    height: calc(100% - 0rem);
                }
                .el-table{
                    .btn{
                        padding: 0.5rem;
                        cursor: pointer;
                        &+.btn{
                            margin-left: 0.2rem;
                        }
                        i{
                            color: #A3AFBB;
                            font-size:0.8rem;
                        }
                        &:hover{
                            i{
                                color: #05CFAB;
                            }
                        }
                    }
                    th{
                        font-weight:initial;
                        height: 3rem;
                        border-top: 1px solid #F0F0F0;
                        border-bottom: 1px solid #F0F0F0;
                        padding: 0;
                        background: #F6F8FA;
                        &>.cell{
                            font-family: AlibabaPuHuiTiR;
                            font-size: 1rem;
                            color: #333333;
                        }
                    }
                    td{
                        padding: 0;
                        height: 3rem;
                        &>.cell,.el-checkbox__label{
                            font-family: AlibabaPuHuiTiR;
                            font-size: 1rem;
                            color: #657085;
                            }
                    }
                    .maintenanceStatus{
                        .text_1{
                            color: #05cfab;
                        }
                        .text_2{
                            color: #FF0C4D;
                        }
                    }
                    .deviceNum{
                        display: flex;
                        align-items: center;
                        padding-left: 1rem;
                        // justify-content: center;
                        img{
                            margin-left: 0.5rem;
                            width: 1.5rem;
                        }
                    }
                    .enable{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .pl_switch{
                            position: relative;
                            display: inline-block;
                            width: 2.33rem;
                            height: 1.3rem;
                            background: #E1EAF1;
                            border-radius: 1.08rem;
                            cursor: pointer;
                            &::after{
                                position: absolute;
                                left: 0.2rem;top: 0.15rem;
                                width: 0.93rem;height: 0.93rem;border-radius: 50%;
                                content: '';
                                background: #A3AFBB;
                                transition: all 0.5s;
                            }
                            &.checked{
                                background: #E1F1E7;
                                &::after{
                                    left: 1.15rem;
                                    background: #05CFAB;
                                }
                            }
                        }
                    }
                }
                .pagination_box{
                    margin-top: 2rem;
                    height: 2.5rem;line-height: 2.5rem;
                    .el-pagination{
                        float: right;
                    }
                    .btn-prev .el-icon{
                        font-size:1rem;
                        color: #666666;
                        font-family: PingFang-SC-Medium;
                    }
                    button{
                        width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                        padding: 0;
                        background: rgba(246, 248, 250, 1);
                        border-radius: 0.2rem;
                    }
                    .el-pager li{
                        margin-left: 0.83rem;
                        width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                        padding: 0;
                        background: rgba(246, 248, 250, 1);
                        border-radius: 0.2rem;
                        &:hover{
                        color: rgba(62, 175, 55, 1);
                        background-color: rgba(62, 175, 55, 0.1);
                        }
                    }
                    .btn-next{
                        margin-left: 0.83rem;
                    }
                    .el-pager li.active{
                        background: rgba(62, 175, 55, 1);
                        color: #FFFFFF;
                    }
                }
            }
        }
        .pushSetting_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .pushSetting_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 30rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .pushSetting_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 30rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 0.5s;
                &.pushSetting_tk_show{
                    right: 0rem; 
                }
                .pushSetting_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .form{
                    margin-top: 1.96rem;
                    .form_item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 3.33rem;line-height: 3.33rem;
                        margin: 0 2.5rem 1.67rem;
                        padding: 0 1.67rem 0 1.08rem;
                        background: #F6F8F7;
                        .laber{
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .el-dropdown{
                            cursor: pointer;
                            i{
                                margin-left: 1.67rem;
                            }
                        }
                        .el-input{
                            width: calc(100% - 8rem);
                            .el-input__inner{
                                font-family: PingFang-SC-Medium;
                                font-size: 1rem;
                                color: #657085;
                                text-align: right;
                                background: initial;
                                border: none;
                            }
                        }
                    }
                    .check_box{
                        margin: 0 2.5rem 1rem;
                        .p1{
                            font-size:1rem;
                            font-family:PingFang-SC-Bold,PingFang-SC;
                            font-weight:bold;
                            color:rgba(51,51,51,1);
                            margin-bottom: 0.5rem;
                        }
                        .el-checkbox{
                            margin: 0 2rem 1rem 0;
                        }
                        .el-checkbox__label{
                            font-size:1rem;
                            font-family:PingFang-SC-Medium,PingFang-SC;
                            font-weight:500;
                            color:rgba(51,51,51,1);
                        }
                        .el-checkbox__input{
                            .el-checkbox__inner{
                                width: 1rem;height: 1rem;
                            }
                            .el-checkbox__inner::after{
                                border:0.1rem solid #fff;
                                border-left: 0;
                                border-top: 0;
                                height: 0.4rem;width: 0.2rem;
                                left: 0.3rem;top: 0.1rem;
                            }
                            &.is-checked{
                                .el-checkbox__inner{
                                    background-color:rgba(5, 207, 171, 1);
                                    border-color: rgba(5, 207, 171, 1);
                                }
                            }
                        }
                        
                    }
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #05CFAB;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #FFFFFF;
                    }
                }
            }
        }
        .jurisdiction_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .jurisdiction_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .jurisdiction_box{
                position: absolute;
                width: 47rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 1s;
                &.jurisdiction_tk_show{
                    right: 0rem; 
                }
                .jurisdiction_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #05CFAB;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #FFFFFF;
                    }
                }
            }
            .tree_box{
                display: flex;
                margin: 2.5rem 2.5rem 0;
                background: #F6F8F7;
                border: 1px solid #F0F0F0;
                height: calc(100% - 14rem);
                
                .el-checkbox__input{
                    &.is-checked,&.is-indeterminate{
                        .el-checkbox__inner{
                            background-color:rgba(5, 207, 171, 1);
                            border-color:rgba(5, 207, 171, 1);
                        }
                    }
                }
                .el-checkbox__inner{
                    width: 1.33rem;height: 1.33rem;
                    &::after{
                        width: 0.3rem;height: 0.6rem;
                        top:0.1rem;left: 0.4rem;
                        border: 0.15rem solid #FFF;
                        border-left: 0;
                        border-top: 0;
                    }
                    &::before{
                        height: 0.25rem;
                        top: 0.45rem;
                    }
                }
                .el-checkbox__label{
                    font-family: PingFang-SC-Medium;
                    font-size: 1.1rem;
                    color: #333333;
                }
                .t{
                    height: 3rem;line-height: 3rem;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 1rem;
                    border-bottom: 1px solid #F0F0F0;
                    background-color: #fff;
                    .label{
                        font-family: PingFang-SbtnC-Medium;
                        font-size: 1.1rem;
                        color: #333333;
                    }
                    .el-checkbox__label{
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #657085;
                    }
                    .btn{
                        padding: 0.5rem;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #657085;
                        span{
                            margin-left: 0.5rem;
                        }
                        i{
                            color: #A3AFBB;
                            font-size:0.8rem;
                        }
                    }
                }
                .b1,.b2{
                    height: calc(100% - 18rem);
                    border-bottom: 1px solid #F0F0F0;
                    position: relative;
                    .li{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        cursor: pointer;
                        padding-right: 1.2rem;
                        height: 2.5rem;line-height: 2.5rem;
                        .iconfont{
                            font-size:0.6rem;
                            color: #A0ACC2;
                            transition: all 0.5s;
                            transform:rotate(0deg);
                        }
                    }
                    .noShow .iconfont{
                        transform:rotate(180deg);
                    }
                    .bg_box{
                        position: absolute;
                        z-index: 0;
                        top: 0;left: 0;
                    }
                    .hotel_box{
                        margin-top: 1rem;
                        margin-left: 1.67rem;
                        // transition: all 1s;
                        overflow: hidden;
                        position: relative;
                        z-index: 1;
                        &.bg{
                            width: calc(100% - 1.67rem);
                            position: relative;
                            .build_box{
                                overflow: initial;
                                position: relative;
                                &.noShow{
                                    .floor_box{
                                        overflow: hidden;
                                    }
                                }
                                &:nth-child(3){
                                    >.bg{
                                        top: -1rem;
                                        width: 1rem;height: 2.3rem;
                                    }
                                }
                                &.noList{
                                    margin-left: 4.5rem;
                                    .bg{
                                        left: -4rem;width: 4rem;
                                    }
                                }
                                .floor_box{
                                    overflow: initial;
                                    position: relative;
                                    &.noShow{
                                        .room_box{
                                            overflow: hidden;
                                        }
                                    }
                                    &:nth-child(3){
                                        >.bg{
                                            top: -1rem;
                                            width: 1rem;height: 2.3rem;
                                        }
                                    }
                                    &.noList{
                                        margin-left: 3rem;
                                        &:nth-child(3){
                                            >.bg{
                                                width: 2.5rem;left: -2.5rem;
                                            }
                                        }
                                    }
                                    .room_box{
                                        overflow: initial;
                                        position: relative;
                                        &:nth-child(3){
                                            >.bg{
                                                top: -1rem;
                                                width: 1rem;height: 2.3rem;
                                            }
                                        }
                                    }
                                }
                                .bg{
                                    position: absolute;
                                    top: -1.2rem;left: -1rem;
                                    width: 1rem;height: 2.5rem;
                                    border-left: 1px dashed #E1E5EA;
                                    border-bottom: 1px dashed #E1E5EA;
                                }
                                .bg_b{
                                    height: 100%;
                                    position: absolute;
                                    top: 0;left: -1rem;
                                    border-left: 1px dashed #E1E5EA;
                                }
                            }
                        }
                        &.noShow{
                            height: 2.5rem;
                        }
                        .build_box{
                            // margin-top: 0.5rem;
                            margin-left: 1.5rem;
                            overflow: hidden;
                            position: relative;
                            &.noShow{
                                height: 2.5rem;
                            }
                            &.noList{
                                margin-left: 4.5rem;
                            }
                            .floor_box{
                                margin-left: 1.5rem;
                                overflow: hidden;
                                &.noShow{
                                    height: 2.5rem;
                                }
                                &.noList{
                                    margin-left: 3rem;
                                }
                                .room_box{
                                    margin-left: 1.5rem;
                                }
                            }
                        }
                    }
                }
                .b2{
                    height: 15rem;
                }
                .left{
                    flex: 1;
                    border-right: 1px solid #F0F0F0;
                }
            }
        }
	}
</style>